module.exports = __webpack_public_path__ + "static/media/nrjantilles.b22ae6ef.png";